"use client"

import styled from "styled-components"
import CustomBlockButton from "../../components/button/CustomBlockButton"
import { useState } from "react"
import { CustomDialog } from "../../components/dialog/v1/CustomDialog"
import { CustomLabelInput } from "../../components/input/CustomLabelInput"
import { useApiInfoContextActionsHook, useApiInfoContextValueHook } from "../../contexts/ApiInfoContext"
import { Link } from "react-router-dom"

const Nav = styled.nav`
  background: linear-gradient(to right, #667eea, #764ba2);
  padding: 1rem 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`

const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
`

const Logo = styled.h1`
    margin: 0;
    color: white;
    font-size: 1.5rem;
    font-weight: bold;
`

const NavLinks = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
`

const NavItem = styled.li`
  margin-left: 1.5rem;
`

const NavLink = styled(Link)`
  color: white;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;

  &:hover {
    color: #ffd700;
  }
`

const SubNav = styled.div`
    padding:10px;
    display: flex;
    align-items: center;
    gap: 10px;
    border-bottom: 1px solid #e0e0e0;
    button{
        width: fit-content;
        height: fit-content;
        padding: 5px 10px;
        background: #333;
        color: white;
        border: none;
    }
`;

const SellertoolApiModalHeader = styled(CustomDialog.Header)`
    padding: 10px;
`;

const SellertoolApiModalBody = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    input{
        border: 1px solid #e0e0e0;
    }

    .buttons{
        display: flex;
        gap: 10px;
        justify-content: flex-end;
        button{
            width:100px;
            height:40px;
            padding: 5px 10px;
            font-weight: 600;
            border-radius: 3px;

            &.primary{
                background: #333;
                color: white;
                border: 1px solid #333;
            }
        }
    }
`;

const Navbar = () => {
    const [sellertoolApiModalOpen, setSellertoolApiModalOpen] = useState(false);

    return (
        <>
            <Nav>
                <NavContainer>
                    <Logo>피아르 셀러툴</Logo>
                    <NavLinks>
                        <NavItem>
                            <NavLink to="/">홈</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink to="/smartstore">스마트스토어</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink to="/coupang">쿠팡</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink to="/return-exchange/search">반품쟁이</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink to="/stock-cycle">재고주기</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink to="https://out-of-stocks.sellertool.io/inventories">기간재고부족</NavLink>
                        </NavItem>
                    </NavLinks>
                </NavContainer>
            </Nav>
            <SubNav>
                <div>셀러툴API</div>
                <CustomBlockButton
                    type='button'
                    onClick={() => setSellertoolApiModalOpen(true)}
                >
                    설정
                </CustomBlockButton>
            </SubNav>

            {sellertoolApiModalOpen &&
                <SellertoolApiModal
                    open={sellertoolApiModalOpen}
                    onClose={() => setSellertoolApiModalOpen(false)}
                />
            }
        </>
    )
}

function SellertoolApiModal({
    open,
    onClose
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const [apiInfo, setApiInfo] = useState({
        apiKey: apiInfoContextValueHook.apiInfo.apiKey,
        secretKey: apiInfoContextValueHook.apiInfo.secretKey
    });
    const apiInfoContextActionsHook = useApiInfoContextActionsHook();

    const handleSave = () => {
        apiInfoContextActionsHook.onSet(apiInfo?.apiKey, apiInfo?.secretKey);
        onClose(false);
    }

    return (
        <CustomDialog
            open={open}
            onClose={() => onClose()}
        >
            <SellertoolApiModalHeader>
                <CustomDialog.Header.Fake />
                <CustomDialog.Header.Title>셀러툴 API 설정</CustomDialog.Header.Title>
                <CustomDialog.Header.Close onClick={() => onClose(false)} />
            </SellertoolApiModalHeader>
            <SellertoolApiModalBody>
                <CustomLabelInput>
                    <CustomLabelInput.Input
                        type='text'
                        value={apiInfo.apiKey || ''}
                        onChange={(event) => setApiInfo({ ...apiInfo, apiKey: event.target.value })}
                    />
                    <CustomLabelInput.Label>API Key</CustomLabelInput.Label>
                </CustomLabelInput>
                <CustomLabelInput>
                    <CustomLabelInput.Input
                        type='text'
                        value={apiInfo.secretKey || ''}
                        onChange={(event) => setApiInfo({ ...apiInfo, secretKey: event.target.value })}
                    />
                    <CustomLabelInput.Label>API Secret</CustomLabelInput.Label>
                </CustomLabelInput>
                <div className='buttons'>
                    <CustomBlockButton
                        type='button'
                        onClick={() => onClose(false)}
                    >
                        취소
                    </CustomBlockButton>
                    <CustomBlockButton
                        type='button'
                        className='primary'
                        onClick={() => handleSave()}
                    >
                        저장
                    </CustomBlockButton>
                </div>
            </SellertoolApiModalBody>
        </CustomDialog>
    )
}
export default Navbar

